var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autocomplete-item"},[_vm._v(" "+_vm._s(_vm.item.name)),(_vm.item.stateName)?_c('span',{staticClass:"autocomplete-item-state"},[_vm._v(" "+_vm._s(_vm.item.stateName))]):_vm._e(),(_vm.item.country)?_c('span',{staticClass:"autocomplete-item-country"},[_vm._v(", "+_vm._s(_vm.$t('countries.' + _vm.item.country)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }